import { render, staticRenderFns } from "./TraspasoCaCo.vue?vue&type=template&id=a8038d34&"
import script from "./TraspasoCaCo.vue?vue&type=script&lang=js&"
export * from "./TraspasoCaCo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports